module.exports = "/_next/static/images/hero-girl-25e38193a943a5b8740375ca8ce1c2ac.svg";